import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { sendAnalyticsEvents } from '../../analytics/common'
import { EVENTS } from '../../analytics/events'
import MainContainer from '../../UI/MainContainer'
import styled from 'styled-components'
import ScreenContent from '../../UI/ScreenContent'
import UIButton from '../../UI/UIButton'
import { selectEventsData } from '../events/eventsSlice'
import { tabletMinWidth, wh } from '../../mixins'
import { selectWebp } from '../ui/uiSlice'
import { usePreloadImages } from '../../helper/useImagePreloader'
import { selectLandingAnimation } from '../plans/plansSlice'

const StyledImg = styled.img`
  ${wh('auto', '362px')}
  object-fit: contain;
  ${({ onePage }) => onePage
    ? `
      height: 300px;
      margin: 24px 0 0 0;
      
      @media screen and (min-width: 1280px) {
        margin: 0 0 24px 0;
        filter: drop-shadow(-28px 26px 39px rgba(0,0,0,.13));
      }
    `
    : `
      margin-bottom: 24px;
  
      @media screen and (max-width: 430px) {
        ${wh('100%', 'auto')}
      }
    
      @media (max-width: 430px) and (max-height: 620px) {
        height: 300px;
      }
    
      @media (max-width: 430px) and (max-height: 550px) {
        height: 250px;
      }
    
      @media (max-width: 360px) or (max-height: 620px) {
        height: 250px;
      }
    
      @media screen and (min-width: ${tabletMinWidth}px){
        margin-bottom: 64px;
      }
    
      @media screen and (max-height: 730px) {
        height: 300px;
      }
    
      @media screen and (max-height: 660px) {
        height: 250px;
      }
    `
  }
`

const FeaturesContainer = ({ history, onePage, title, adaptiveHeight, eventName, nextPage, imagePreload, imageName, imageAlt }) => {
  const { t } = useTranslation()
  const eventsData = useSelector(selectEventsData)
  const isWebp = useSelector(selectWebp)
  const isAnimationLanding = useSelector(selectLandingAnimation);

  usePreloadImages(imagePreload)

  useEffect(
    () => !onePage && sendAnalyticsEvents(EVENTS[`${eventName}Shown`], eventsData),
    [eventName, eventsData, onePage]
  )

  const onContinueClick = () => {
    sendAnalyticsEvents(EVENTS[`${eventName}Submitted`], eventsData)
    history.push(nextPage)
  }

  return (
    <MainContainer adaptiveHeight={adaptiveHeight} customPadding={'0 24px 24px'}>
      <ScreenContent title={t(title)} text={t(`${title}_description`)} onePage={onePage} />
      <StyledImg
        src={
          isAnimationLanding
            ? `../assets/options/gifs/${imageName}.gif`
            : isWebp
            ? `../assets/options/${imageName}.webp`
            : `../assets/options/${imageName}.png`
        }
        alt={imageAlt}
        onePage={onePage}
      />
      {!onePage && (
        <UIButton onClick={onContinueClick} bottomPosition={'24px'} customBeforeBg={'none'}>
          {t('continue')}
        </UIButton>
      )}
    </MainContainer>
  )
}

export default FeaturesContainer
